<div
  *ngLet="{
    anchorBounds: anchorBounds | async,
    top: top | async,
    left: left | async,
    modal: modal | async
  } as vm"
  #scrim
  class="scrim"
  [class.full]="vm.modal"
  (click)="$event.stopPropagation()"
>
  <div
    class="callout"
    [class.no-transition]="!calloutRight"
    [class.shadow]="showShadow"
    [lockScroll]="vm.modal"
    [style.left.px]="vm.left"
    [style.top.px]="vm.top"
    (clientSize)="calloutSize.next($event)"
    modalEscape
    (escape)="closeTrigger.next(null)"
  >
    <div
      [style.height.px]="height | async"
      [class.rv-scrollable]="scrollable"
      [class.rv-card]="cardStyling"
    >
      <ng-content></ng-content>
    </div>
  </div>
</div>
